<div class="roi-container pt-0 px-4 md:px-6 pb-0 min-h-screen" style="margin-top: -36px;">
  <p-toast></p-toast>

  <!-- VIEW 1.5: Loading Screen Overlay -->
  <div *ngIf="isLoading" class="roi-loading-overlay">
    <div class="loader-content flex flex-column align-items-center justify-content-center">
      <div class="custom-dots-loader">
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
        <div class="loader-dot"></div>
      </div>
      <p class="loading-text">Please wait while we calculate your ROI results</p>
    </div>
  </div>

  <!-- GradPilots Brand Logo (Always Centered at Top) -->
  <!-- <div class="brand-header text-center mb-5" *ngIf="activeView !== 'landing'">
    <div class="brand-logo mb-2">
      <img src="assets/images/logo.svg" alt="GradPilots Logo" class="logo-image" (click)="resetCalculator()" style="cursor: pointer;">
    </div>
  </div> -->

  <!-- Main Scrollable Landing + Form View -->
  <div *ngIf="activeView === 'landing'" class="flex flex-column gap-6">
    <!-- VIEW 0: Landing / Hero Screen -->
    <div
      class="landing-hero w-full flex flex-column lg:flex-row align-items-center justify-content-between gap-6 py-6 px-0 lg:px-4">
      <!-- Left side text -->
      <div class="hero-left">
        <span class="free-tool-tag"><i class="pi pi-star-fill"></i> ROI Calculator</span>
        <h1 class="hero-title">Is Your Dream Degree <span class="accent-text">worth it ?</span></h1>
        <p class="hero-subtitle">Calculate the real return on your High-Ed investment. Find out exactly what you'll
          spend, what you'll earn, and when you'll break even.</p>
        <button class="btn btn-yellow btn-lg px-5 py-3 mb-4" (click)="startFullForm()">Calculate my ROI</button>
      </div>

      <!-- Right side overlay images and background circle -->
      <div class="hero-right">
        <div class="circle-bg"></div>
        <div class="cards-container">
          <img src="assets/images/ROI_intro.png" alt="Calculating Card" class="card-img card" (click)="startFullForm()">
        </div>
      </div>
    </div>

    <!-- VIEW 1: Input Form -->
    <div id="roi-form-container" class="form-card mx-auto p-4 md:p-6 relative">
      <!-- Decorative Floating Elements -->
      <img src="assets/images/ThinkCloud.png" alt="" class="decor-img decor-cloud">
      <img src="assets/images/CogWheels.png" alt="" class="decor-img decor-cogs">
      <img src="assets/images/ROI-doted.png" alt="" class="decor-img decor-dotted-line">
      <img src="assets/images/ROI-leftYellow.png" alt="" class="decor-img decor-left-yellow">
      <img src="assets/images/ROI-rightYellow.png" alt="" class="decor-img decor-right-yellow">
      <img src="assets/images/ROI-purpleDots.png" alt="" class="decor-img decor-purple-dots">

      <div class="form-header-container text-center mb-5">
        <h1 class="calculator-title m-0">GradPilots ROI Calculator</h1>
        <div class="accent-underline"></div>
      </div>

      <form [formGroup]="roiForm" (ngSubmit)="calculateRoi()" class="flex flex-column gap-5" autocomplete="off">

        <!-- STEP 1: Your Program Details -->
        <div class="step-card">
          <div class="step-header">
            <span class="step-number">1</span>
            <h2 class="step-title">Your Program Details</h2>
          </div>

          <div class="step-content">
            <div class="field mb-4">
              <label class="label-heading">WHAT LEVEL OF STUDY?</label>
              <div class="segmented-control">
                <button type="button" class="segmented-btn" [class.active]="roiForm.get('level')?.value === 'UG'"
                  (click)="roiForm.get('level')?.setValue('UG')">
                  Undergraduate
                </button>
                <button type="button" class="segmented-btn" [class.active]="roiForm.get('level')?.value === 'PG'"
                  (click)="roiForm.get('level')?.setValue('PG')">
                  Postgraduate
                </button>
              </div>
            </div>

            <div class="form-grid">
              <div class="field">
                <label for="planToStart-inline" class="label-heading">WHEN DO YOU PLAN TO START?</label>
                <p-dropdown id="planToStart-inline" [options]="startYears" formControlName="planToStart"
                  optionLabel="name" optionValue="code" placeholder="Select start year" styleClass="w-full"
                  appendTo="body"></p-dropdown>
              </div>

              <div class="field">
  <label for="university-inline" class="label-heading">WHICH UNIVERSITY?</label>
  <div class="university-wrapper" [class.is-locked]="!roiForm.get('level')?.value">
    <p-autoComplete id="university-inline" formControlName="university"
      [suggestions]="universitySearchSuggestions" (completeMethod)="searchUniversities($event)" field="name"
      placeholder="Search university (e.g. LSE)..." styleClass="w-full" [dropdown]="true"
      forceSelection="true" [disabled]="!roiForm.get('level')?.value"
      (onDropdownClick)="blockIfLocked($event)" (onFocus)="blockIfLocked($event)" appendTo="body">
    </p-autoComplete>
  </div>
  <small *ngIf="!roiForm.get('level')?.value" class="text-xs text-500 italic mt-1 block">Please select
    level of study first.</small>
</div>
            </div>

            <div class="form-grid" *ngIf="roiForm.get('level')?.value === 'PG'">
              <div class="field">
                <label for="school-inline" class="label-heading">WHICH SCHOOL?</label>
                <p-dropdown id="school-inline" [options]="schoolsList" formControlName="school" optionLabel="name"
                  placeholder="Select school" styleClass="w-full"
                  [disabled]="isLoadingCourses || schoolsList.length === 0" appendTo="body"></p-dropdown>
                <span *ngIf="isLoadingCourses" class="text-xs text-500 italic mt-1 block"><i
                    class="pi pi-spin pi-spinner mr-1"></i> Loading schools...</span>
              </div>

              <div class="field" *ngIf="roiForm.get('school')?.value">
                <label for="course-inline" class="label-heading">WHICH COURSE?</label>
                <p-dropdown id="course-inline" [options]="coursesList" formControlName="course" optionLabel="name"
                  placeholder="Select course" styleClass="w-full" [disabled]="coursesList.length === 0"
                  appendTo="body"></p-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 2: Your Financial Situation -->
        <div class="step-card">
          <div class="step-header">
            <span class="step-number">2</span>
            <h2 class="step-title">Your Financial Situation</h2>
          </div>

          <div class="step-content">
            <div class="field">
              <label class="label-heading">DO YOU HAVE ANY SCHOLARSHIPS SECURED?</label>
              <div class="scholarship-toggle flex gap-3">
                <button type="button" class="toggle-btn" [class.active]="hasScholarship"
                  (click)="toggleScholarship(true)">
                  Yes
                </button>
                <button type="button" class="toggle-btn" [class.active]="!hasScholarship"
                  (click)="toggleScholarship(false)">
                  No
                </button>
              </div>
            </div>

            <div class="field" *ngIf="hasScholarship">
              <label for="scholarshipAmount-inline" class="label-heading">SCHOLARSHIP AMOUNT</label>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{ currencySymbol }}</span>
                <input pInputText id="scholarshipAmount-inline" type="number" formControlName="scholarshipAmount"
                  placeholder="10,000" class="w-full">
              </div>
            </div>

            <div class="field">
              <label class="label-heading">LIVING:</label>
              <div class="living-segmented">
                <div class="living-option" [class.selected]="roiForm.get('livingSituation')?.value === 'On-campus'"
                  (click)="roiForm.get('livingSituation')?.setValue('On-campus')">
                  <span class="radio-dot"></span> On-campus
                </div>
                <div class="living-option" [class.selected]="roiForm.get('livingSituation')?.value === 'Off-campus'"
                  (click)="roiForm.get('livingSituation')?.setValue('Off-campus')">
                  <span class="radio-dot"></span> Off-campus
                </div>
                <div class="living-option"
                  [class.selected]="roiForm.get('livingSituation')?.value === 'Living with relatives'"
                  (click)="roiForm.get('livingSituation')?.setValue('Living with relatives')">
                  <span class="radio-dot"></span> Living with relatives (free)
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Recommendation Checkbox Banner -->
        <div class="loan-banner">
          <p-checkbox formControlName="loanRecommendation" [binary]="true" id="loanRec-inline"
            class="mr-2"></p-checkbox>
          <label for="loanRec-inline" class="cursor-pointer font-semibold text-800 line-height-3">
            I would also like a <span class="accent-bold-text">personalised loan recommendation</span> based on my
            profile.
          </label>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="btn-calculate-roi w-full" [disabled]="isLoading">
          <i class="pi pi-calculator mr-2" *ngIf="!isLoading"></i>
          <i class="pi pi-spin pi-spinner mr-2" *ngIf="isLoading"></i>
          <span>Calculate My ROI</span>
        </button>

      </form>
    </div>
  </div>

  <!-- VIEW 2: Results Analysis Dashboard -->
  <div *ngIf="activeView === 'dashboard' && calculationResult"
    class="results-dashboard max-w-7xl mx-auto flex flex-column gap-5 pb-8 mb-6">

    <!-- Back to Form Button -->
    <div class="flex align-items-center mb-1">
      <button (click)="goBackToForm()" class="btn-back-to-form">
        <i class="pi pi-arrow-left mr-2"></i>
        <span>Back to Form</span>
      </button>
    </div>

    <!-- Top Header Banner -->
    <div
      class="flex flex-column sm:flex-row align-items-start sm:align-items-center justify-content-between gap-3 mb-2 w-full">
      <div class="flex flex-column">
        <h1 class="dashboard-title text-900 font-extrabold m-0">Your Personalized ROI Analysis</h1>
        <p class="dashboard-subtitle text-600 mt-2 font-bold flex align-items-center gap-2">
          <span class="uni-name">{{ selectedUniversityName }}</span>
          <span class="bullet-dot">&bull;</span>
          <span class="course-name" *ngIf="roiForm.get('course')?.value">{{ roiForm.get('course')?.value?.name }}</span>
          <span class="bullet-dot" *ngIf="roiForm.get('course')?.value">&bull;</span>
          <span class="start-year">{{ roiForm.get('planToStart')?.value }}</span>
        </p>
      </div>
      <button class="btn-change-course" (click)="openFormDialog()">
        <span>Try Another Course</span>
        <span class="ml-2 font-bold">&gt;</span>
      </button>
    </div>

    <!-- Row 1: 4 Blue KPI Cards -->
    <div class="grid w-full m-0 p-0 justify-content-between">
      <div class="col-12 sm:col-6 lg:col-3 p-2">
        <div class="kpi-card flex flex-column justify-content-center">
          <span class="kpi-label">Net investment</span>
          <span class="kpi-value">{{ calculationResult.investment.totalInvestment.local }}</span>
          <svg class="kpi-wave" viewBox="0 0 300 135" preserveAspectRatio="none">
            <path d="M 0 90 C 80 135, 180 120, 230 95 C 270 75, 290 65, 300 55 L 300 135 L 0 135 Z" fill="#1322b7" />
          </svg>
        </div>
      </div>
      <div class="col-12 sm:col-6 lg:col-3 p-2">
        <div class="kpi-card flex flex-column justify-content-center">
          <span class="kpi-label">Median Starting Salary</span>
          <span class="kpi-value">{{ calculationResult.outlook.startingSalary.local }}</span>
          <span class="kpi-subtext">per year avg</span>
          <svg class="kpi-wave" viewBox="0 0 300 135" preserveAspectRatio="none">
            <path d="M 0 90 C 80 135, 180 120, 230 95 C 270 75, 290 65, 300 55 L 300 135 L 0 135 Z" fill="#1322b7" />
          </svg>
        </div>
      </div>
      <div class="col-12 sm:col-6 lg:col-3 p-2">
        <div class="kpi-card flex flex-column justify-content-center">
          <span class="kpi-label">Break-Even</span>
          <span class="kpi-value">{{ calculationResult.returns.breakEvenYears }} Years</span>
          <span class="kpi-subtext">from graduation</span>
          <svg class="kpi-wave" viewBox="0 0 300 135" preserveAspectRatio="none">
            <path d="M 0 90 C 80 135, 180 120, 230 95 C 270 75, 290 65, 300 55 L 300 135 L 0 135 Z" fill="#1322b7" />
          </svg>
        </div>
      </div>
      <div class="col-12 sm:col-6 lg:col-3 p-2">
        <div class="kpi-card flex flex-column justify-content-center">
          <span class="kpi-label">10 year ROI</span>
          <span class="kpi-value">{{ calculationResult.returns.tenYearRoiPercent }}%</span>
          <svg class="kpi-wave" viewBox="0 0 300 135" preserveAspectRatio="none">
            <path d="M 0 90 C 80 135, 180 120, 230 95 C 270 75, 290 65, 300 55 L 300 135 L 0 135 Z" fill="#1322b7" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Row 2: Investment Required & Employment Outlook (Side-by-Side Cards) -->
    <div class="grid w-full m-0 p-0 justify-content-between gap-4 lg:gap-0">

      <!-- Investment Required Card -->
      <div class="col-12 lg:col-6 p-2">
        <div class="results-card h-full flex flex-column">
          <div class="results-card-header">
            <span>Investment Required</span>
          </div>
          <div class="results-card-content p-4 flex flex-column gap-3">
            <div class="breakdown-row flex align-items-center justify-content-between">
              <span class="row-label">Total Tuition</span>
              <span class="row-pill-val">+{{ calculationResult.investment.tuition.local }}</span>
            </div>
            <div class="breakdown-row flex align-items-center justify-content-between">
              <span class="row-label">Living Costs</span>
              <span class="row-pill-val">+{{ calculationResult.investment.livingCosts.local }}</span>
            </div>
            <div class="breakdown-row flex align-items-center justify-content-between"
              *ngIf="calculationResult.investment.scholarships.rawLocal > 0">
              <span class="row-label">Scholarships</span>
              <span class="row-pill-val bg-green-light">-{{ calculationResult.investment.scholarships.local }}</span>
            </div>

            <div class="divider border-top-1 border-gray-200 my-2"></div>

            <div class="total-row flex align-items-center justify-content-between">
              <span class="total-label">TOTAL INVESTMENT</span>
              <span class="total-value">{{ calculationResult.investment.totalInvestment.local }}</span>
            </div>

            <!-- Bottom Scholarships Opportunity Banner -->
            <div class="mt-4 flex align-items-center justify-content-between cursor-pointer"
              style="background-color: #fcffce; border: 1px solid #f2f78b; border-radius: 40px; padding: 12px 20px;"
              *ngIf="calculationResult.scholarshipOpportunities && calculationResult.scholarshipOpportunities.length > 0"
              (click)="navigateToScholarships()">
              <div class="flex align-items-center gap-3">
                <i class="pi pi-verified text-2xl" style="color: #0b1c77;"></i>
                <div class="flex flex-column">
                  <span class="font-bold text-sm" style="color: #0b1c77; letter-spacing: -0.01em;">
                    {{ calculationResult.scholarshipOpportunities.length }} scholarships available
                  </span>
                  <span style="font-size: 0.7rem; color: #1e293b; margin-top: 2px;">
                    for {{ selectedUniversityName }} students
                  </span>
                </div>
              </div>
              <i class="pi pi-angle-right text-lg font-bold" style="color: #0b1c77;"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Employment Outlook Card -->
      <div class="col-12 lg:col-6 p-2">
        <div class="results-card h-full flex flex-column">
          <div class="results-card-header">
            <span>Employment Outlook</span>
          </div>
          <div class="results-card-content bg-circles p-4 flex flex-column gap-3">

            <!-- Circular Progress Donut Chart -->
            <div class="flex align-items-center gap-4 mb-4 mt-2">
              <div class="donut-chart-container relative flex align-items-center justify-content-center"
                style="width: 85px; height: 85px;">
                <!-- SVG circular gauge -->
                <svg width="85" height="85" viewBox="0 0 36 36" class="donut-svg">
                  <path class="donut-bg"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                    stroke="#eef2ff" stroke-width="4"></path>
                  <path class="donut-fg"
                    [attr.stroke-dasharray]="calculationResult.outlook.employedPercentage + ', 100'"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                    stroke="#0b1c77" stroke-width="4.5" stroke-linecap="round"></path>
                </svg>
                <span class="donut-percentage font-black text-blue-900 text-xl absolute">{{
                  calculationResult.outlook.employedPercentage }}%</span>
              </div>
              <div class="flex flex-column">
                <span class="donut-label-title text-900 font-extrabold text-xl mb-1">Employment rate</span>
                <span class="donut-label-subtitle text-500 text-xs font-semibold">within {{ roiForm.get('level')?.value
                  === 'PG' ? '3' : '6' }} months of graduation</span>
              </div>
            </div>

            <!-- Salary Details Pills -->
            <div class="breakdown-row flex align-items-center justify-content-between mb-2">
              <span class="row-label">Median Starting Salary</span>
              <span class="row-pill-val">{{ calculationResult.outlook.startingSalary.local }}/ yr</span>
            </div>
            <div class="breakdown-row flex align-items-center justify-content-between mb-2">
              <span class="row-label">Median Earnings Five Years Post Completion</span>
              <span class="row-pill-val">{{ calculationResult.outlook.afterTaxSalary.local }}/ yr</span>
            </div>
            <div class="breakdown-row flex align-items-center justify-content-between mb-4">
              <span class="row-label">Year 1 Net Savings</span>
              <span class="row-pill-val">{{ calculationResult.outlook.year1NetSavings.local }}/ yr</span>
            </div>

            <!-- <div class="flex justify-content-center mt-auto">
              <a class="view-industries-link flex align-items-center gap-2 font-bold text-xs hover:underline cursor-pointer" (click)="showSimplified()">
                <span>View Top Industries</span>
                <i class="pi pi-angle-double-up text-xs"></i>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Row 3: Break Even Timeline -->
    <div class="results-card w-full">
      <div class="results-card-header">
        <span>Break Even Timeline</span>
      </div>
      <div class="results-card-content p-4 flex flex-column gap-3">
        <div class="flex align-items-baseline gap-2 mb-3 mt-1 px-3">
          <span class="font-extrabold text-blue-900"
            style="font-size: 3.25rem; line-height: 1; letter-spacing: -0.05em;">{{
            calculationResult.returns.breakEvenYears }}</span>
          <span class="font-extrabold text-blue-900" style="font-size: 1.5rem; letter-spacing: -0.02em;">years</span>
          <span class="text-500 font-medium ml-1" style="font-size: 0.75rem;">from graduation to full cost
            recovery</span>
        </div>

        <!-- Break-Even Curve SVG Chart -->
        <div class="svg-chart-wrapper w-full relative border-none"
          style="height: 240px; padding: 10px 10px 25px 60px; box-sizing: border-box; margin: 0 auto;">
          <!-- Left Y-Axis Labels -->
          <div class="chart-y-axis"
            style="position: absolute; left: 10px; top: 10px; bottom: 25px; width: 45px; display: flex; flex-direction: column; justify-content: space-between; align-items: flex-end; pointer-events: none; z-index: 10;">
            <span *ngFor="let label of getBreakEvenYLabels()"
              style="font-size: 14px; font-weight: 600; color: #1e293b; line-height: 1;">{{ label }}</span>
          </div>

          <!-- Bottom X-Axis Labels -->
          <div class="chart-x-axis"
            style="position: absolute; left: 60px; right: 10px; bottom: 5px; height: 20px; display: flex; flex-direction: row; justify-content: space-between; pointer-events: none; z-index: 10;">
            <span
              style="font-size: 14px; font-weight: 500; color: #1e293b; width: 40px; text-align: center; margin-left: -20px;">start</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">Yr
              1</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">Yr
              2</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">Yr
              3</span>
            <span
              style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center; margin-right: -25px;">Yr
              4</span>
          </div>

          <!-- SVG Chart Area -->
          <svg class="w-full h-full" viewBox="0 0 650 200" preserveAspectRatio="none">
            <!-- Grid Lines -->
            <line x1="0" y1="0" x2="650" y2="0" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="40" x2="650" y2="40" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="80" x2="650" y2="80" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="120" x2="650" y2="120" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="160" x2="650" y2="160" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="200" x2="650" y2="200" stroke="#f1f5f9" stroke-width="1.5" />

            <!-- Break-Even curve line path -->
            <path [attr.d]="getBreakEvenPath()" fill="none" stroke="url(#lineGrad)" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />

            <!-- Define Gradients -->
            <defs>
              <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#ff8f8f" /> <!-- Red -->
                <stop offset="25%" stop-color="#d4aa63" /> <!-- Orange/Brown at Year 1 -->
                <stop offset="60%" stop-color="#84e058" /> <!-- Greenish at Year 2/3 -->
                <stop offset="100%" stop-color="#4ade80" /> <!-- Bright Green at end -->
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <!-- Row 4: Return on Investment -->
    <div class="results-card w-full">
      <div class="results-card-header">
        <span>Return on Investment</span>
      </div>
      <div class="results-card-content p-4 flex flex-column gap-3">
        <div
          class="flex flex-column sm:flex-row align-items-start sm:align-items-center justify-content-between w-full gap-4 mb-4 px-3 mt-1">
          <div class="flex gap-4 sm:gap-6">
            <div class="flex flex-column gap-1">
              <span class="text-500 font-medium text-xs">Net savings</span>
              <span class="font-extrabold text-blue-900" style="font-size: 2rem; letter-spacing: -0.03em;">{{
                selectedRoiYears === 10 ? calculationResult.returns.tenYearNetSavings.local :
                calculationResult.returns.fiveYearNetSavings.local }}</span>
            </div>
            <div class="flex flex-column gap-1">
              <span class="text-500 font-medium text-xs">Total ROI</span>
              <span class="font-extrabold text-blue-900" style="font-size: 2rem; letter-spacing: -0.03em;">{{
                selectedRoiYears === 10 ? calculationResult.returns.tenYearRoiPercent :
                calculationResult.returns.fiveYearRoiPercent }}%</span>
            </div>
          </div>
          <!-- Toggle Pill Control -->
          <div class="flex align-items-center bg-white border-1 border-300 align-self-center sm:align-self-auto"
            style="border-radius: 30px; padding: 2px;">
            <button class="border-none font-bold text-xs cursor-pointer transition-colors transition-duration-200"
              [class.bg-blue-900]="selectedRoiYears === 5" [class.text-white]="selectedRoiYears === 5"
              [class.bg-transparent]="selectedRoiYears !== 5" [class.text-900]="selectedRoiYears !== 5"
              [class.shadow-1]="selectedRoiYears === 5" (click)="selectedRoiYears = 5"
              style="border-radius: 20px; padding: 6px 14px; outline: none;">5 years</button>
            <button class="border-none font-bold text-xs cursor-pointer transition-colors transition-duration-200"
              [class.bg-blue-900]="selectedRoiYears === 10" [class.text-white]="selectedRoiYears === 10"
              [class.bg-transparent]="selectedRoiYears !== 10" [class.text-900]="selectedRoiYears !== 10"
              [class.shadow-1]="selectedRoiYears === 10" (click)="selectedRoiYears = 10"
              style="border-radius: 20px; padding: 6px 14px; outline: none;">10 years</button>
          </div>
        </div>

        <!-- ROI Curve SVG Chart -->
        <div class="svg-chart-wrapper w-full relative border-none"
          style="height: 250px; padding: 10px 50px 25px 60px; box-sizing: border-box; margin: 0 auto;">
          <!-- Left Y-Axis Labels -->
          <div class="chart-y-axis"
            style="position: absolute; left: 10px; top: 10px; bottom: 25px; width: 45px; display: flex; flex-direction: column; justify-content: space-between; align-items: flex-end; pointer-events: none; z-index: 10;">
            <span *ngFor="let label of getRoiLeftLabels()"
              style="font-size: 14px; font-weight: 600; color: #1e293b; line-height: 1;">{{ label }}</span>
          </div>

          <!-- Right Y-Axis Labels (Percentages) -->
          <div class="chart-y-axis-right"
            style="position: absolute; right: 10px; top: 10px; bottom: 25px; width: 35px; display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; pointer-events: none; z-index: 10;">
            <span *ngFor="let label of getRoiRightLabels()"
              style="font-size: 14px; font-weight: 600; color: #1e293b; line-height: 1;">{{ label }}</span>
          </div>

          <!-- Bottom X-Axis Labels -->
          <div class="chart-x-axis"
            style="position: absolute; left: 60px; right: 50px; bottom: 5px; height: 20px; display: flex; flex-direction: row; justify-content: space-between; pointer-events: none; z-index: 10;">
            <span
              style="font-size: 14px; font-weight: 500; color: #1e293b; width: 40px; text-align: center; margin-left: -20px;">start</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">{{
              selectedRoiYears === 10 ? 'Yr 2.5' : 'Yr 1.25' }}</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">{{
              selectedRoiYears === 10 ? 'Yr 5' : 'Yr 2.5' }}</span>
            <span style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center;">{{
              selectedRoiYears === 10 ? 'Yr 7.5' : 'Yr 3.75' }}</span>
            <span
              style="font-size: 14px; font-weight: 500; color: #1e293b; width: 50px; text-align: center; margin-right: -25px;">{{
              selectedRoiYears === 10 ? 'Yr 10' : 'Yr 5' }}</span>
          </div>

          <!-- SVG Chart Area -->
          <svg class="w-full h-full" viewBox="0 0 650 200" preserveAspectRatio="none">
            <!-- Grid Lines -->
            <line x1="0" y1="0" x2="650" y2="0" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="40" x2="650" y2="40" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="80" x2="650" y2="80" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="120" x2="650" y2="120" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="160" x2="650" y2="160" stroke="#f1f5f9" stroke-width="1.5" />
            <line x1="0" y1="200" x2="650" y2="200" stroke="#f1f5f9" stroke-width="1.5" />

            <!-- ROI Curve line path -->
            <path [attr.d]="getRoiPath()" fill="none" stroke="url(#roiLineGrad)" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />

            <!-- Define Gradients -->
            <defs>
              <linearGradient id="roiLineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#000885" /> <!-- Deep navy blue at start -->
                <stop offset="50%" stop-color="#4f46e5" /> <!-- Indigo in middle -->
                <stop offset="100%" stop-color="#818cf8" /> <!-- Light indigo/purple at end -->
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <!-- Row 5: Loan Viability (Card) -->
    <div *ngIf="roiForm.get('loanRecommendation')?.value" class="results-card w-full"
      style="background-color: #000885; border-radius: 20px;">
      <div class="results-card-header bg-transparent text-white" style="padding: 1.25rem 1.5rem 1rem;">
        <span class="font-extrabold uppercase" style="color: #cddc39; letter-spacing: 0.05em; font-size: 0.9rem;">Loan
          Viability</span>
      </div>
      <div class="results-card-content p-4 flex flex-column gap-3"
        style="background-color: #fefce8; border-radius: 20px; margin: 0; min-height: 120px;">
        <!-- Gauge labels row -->
        <div class="grid text-center uppercase mb-1 w-full m-0 p-0"
          style="font-size: 0.65rem; font-weight: 700; letter-spacing: 0.05em; color: #64748b;">
          <div class="col">Borrow Carefully</div>
          <div class="col">Loan is Good</div>
          <div class="col">Loan is Great</div>
          <!-- <div class="col">Favourable</div> -->
          <div class="col font-extrabold" style="color: #0b1c77; font-size: 0.7rem;">Amazing Investment</div>
        </div>

        <!-- Slider gauge bar -->
        <div class="gauge-slider-bar-container relative w-full mb-1 mt-1"
          style="height: 12px; background-color: #e0e7ff; border-radius: 20px;">
          <!-- Filled blue gradient track -->
          <div class="absolute top-0 left-0 h-full" [style.width]="getRecommendationPointerPosition()"
            style="background: linear-gradient(90deg, #1e3a8a 0%, #4f46e5 100%); border-radius: 20px; transition: width 0.3s ease;">
          </div>

          <!-- Yellow Thumb pointer -->
          <div class="slider-pointer absolute border-circle" [style.left]="getRecommendationPointerPosition()"
            style="width: 22px; height: 22px; background-color: #fef08a; top: 50%; transform: translate(-50%, -50%); z-index: 10; box-shadow: 0 2px 6px rgba(0,0,0,0.25);">
          </div>
        </div>

        <!-- Advisability labels row -->
        <div class="flex align-items-center justify-content-between w-full mt-1 px-1">
          <span class="font-bold" style="color: #0b1c77; font-size: 0.7rem;">Should Not Consider</span>
          <span class="font-bold" style="color: #0b1c77; font-size: 0.7rem;">Definitely Consider</span>
        </div>
      </div>
    </div>

    <!-- Row 6: Action Footer Banner -->
    <div
      class="footer-cta-banner flex align-items-center justify-content-between relative overflow-hidden w-full mt-4 py-4 md:py-0"
      style="background-color: #0b1c77; border-radius: 12px; min-height: 130px; height: auto; box-shadow: 0 10px 25px rgba(11,28,119,0.15);">

      <!-- Left side graphical isometric sketch (Group 716) -->
      <div class="hidden md:flex absolute left-0 top-0 h-full z-2 align-items-center justify-content-start"
        style="width: 300px;">
        <img src="assets/images/Group 716.png" alt="Isometric graphic"
          style="height: 100%; width: auto; object-fit: contain; margin-left: 1rem;">
      </div>

      <!-- Center content -->
      <div class="flex flex-column align-items-center justify-content-center z-3 w-full">
        <div class="flex align-items-center gap-2 mb-3">
          <!-- Dashed decorative marks (Group 43011) -->
          <img src="assets/images/Group 43011.png" alt="dashes"
            style="height: 20px; width: auto; margin-right: 4px; margin-top: -5px;">
          <h2 class="m-0 text-white font-bold" style="font-size: 1.1rem; letter-spacing: 0.02em;">
            Choose what to do with the <span style="color: #cddc39;">results</span>
          </h2>
        </div>

        <!-- Action buttons -->
        <div class="flex flex-wrap justify-content-center gap-3 w-full px-3">
          <!-- <button class="btn-cta-action flex align-items-center justify-content-center gap-2 border-none cursor-pointer transition-transform transition-duration-200 hover:scale-105" 
                  style="background-color: #cddc39; border-radius: 8px; padding: 0.6rem 1.5rem; color: #0b1c77; font-weight: 800; font-size: 0.75rem; box-shadow: 0 4px 15px rgba(200,214,38,0.25);" (click)="saveResults()">
            <i class="pi pi-heart text-xs font-bold"></i>
            <span>Save Results</span>
          </button> -->
          <button
            class="btn-cta-action flex align-items-center justify-content-center gap-2 border-none cursor-pointer transition-transform transition-duration-200 hover:scale-105"
            style="background-color: #cddc39; border-radius: 8px; padding: 0.6rem 1.5rem; color: #0b1c77; font-weight: 800; font-size: 0.75rem; box-shadow: 0 4px 15px rgba(200,214,38,0.25);"
            (click)="mentorShareMenu.toggle($event)">
            <i class="pi pi-share-alt text-xs font-bold"></i>
            <span>Share with Mentor</span>
          </button>

          <!-- Mentor Share Overlay Panel -->
          <p-overlayPanel #mentorShareMenu [showCloseIcon]="false">
            <div class="flex flex-column gap-2 p-1" style="min-width: 210px;">
              <b class="text-xs font-bold text-gray-500 mb-2 uppercase tracking-wider">Share with</b>

              <ng-container *ngIf="studentMentors.length > 0; else noMentorTemplate">
                <div *ngFor="let mentor of studentMentors"
                  class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-blue-50 transition-colors"
                  (click)="selectedMentorToShare = mentor; shareRoiWithMentor(); mentorShareMenu.hide()">
                  <div class="flex flex-column">
                    <span class="text-sm font-bold text-gray-800">{{ mentor.label }}</span>
                    <span class="text-xs text-gray-500">Your Mentor</span>
                  </div>
                </div>
              </ng-container>

              <ng-template #noMentorTemplate>
                <div
                  class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-orange-50 transition-colors"
                  (click)="navigateToMentors(); mentorShareMenu.hide()">
                  <div class="flex flex-column">
                    <span class="text-sm font-bold text-gray-800">No Mentor Found</span>
                    <span class="text-xs text-blue-600 font-medium">Choose your mentor</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </p-overlayPanel>
          <button
            class="btn-cta-action flex align-items-center justify-content-center gap-2 border-none cursor-pointer transition-transform transition-duration-200 hover:scale-105"
            style="background-color: #cddc39; border-radius: 8px; padding: 0.6rem 1.5rem; color: #0b1c77; font-weight: 800; font-size: 0.75rem; box-shadow: 0 4px 15px rgba(200,214,38,0.25);"
            (click)="share()">
            <i class="pi pi-share-alt text-xs font-bold"></i>
            <span>Share with Parents</span>
          </button>
        </div>
      </div>

      <!-- Right side decoration fallback circle -->
      <div class="absolute circle-bg-shape pointer-events-none z-0"
        style="background: #8b85ff; border-radius: 50%; width: 250px; height: 250px; right: -80px; top: -100px;"></div>
    </div>

    <!-- Disclaimer -->
    <div class="mt-5 mb-2 px-2">
      <h3 class="font-bold mb-2 text-base" style="color: #9aa2ac;">Disclaimer :</h3>
      <p class="m-0 line-height-3 text-xs" style="color: #9aa2ac; font-style: italic;">
        (1) The calculator covers international student tuition fees; home student fees will differ. (2) A flat
        effective tax rate of 25% is applied globally, which also absorbs the effects of inflation and salary growth
        variation across years. (3) Living costs during study and post-graduation are assumed to be identical, based on
        the same city and living situation. (4) Post-graduation accommodation is assumed to be off-campus regardless of
        living arrangement during study. (5) A uniform salary increment of 5% per annum is assumed throughout the
        10-year projection period. (6) MSc tuition fees for PG are averaged across all MSc courses within the selected
        school type and may not reflect the exact fees for your specific course.
      </p>
    </div>

  </div>

  <!-- VIEW 3: Simplify it! Detailed Summary Screen (p-dialog popup overlay) -->
  <p-dialog [(visible)]="simplifiedVisible" [modal]="true" [responsive]="true" [dismissableMask]="true"
    [closable]="true" [draggable]="false" [resizable]="false"
    styleClass="simplify-dialog max-w-lg mx-auto border-round-2xl overflow-hidden" contentStyleClass="p-0">

    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-sparkles text-blue-600 text-xl"></i>
        <h2 class="m-0 text-900 font-bold text-lg">Simplify it!</h2>
      </div>
    </ng-template>

    <div class="p-4 md:p-5">
      <p class="simplified-subtitle text-left text-600 mb-4 font-semibold">Here's what your ROI numbers actually mean
      </p>

      <!-- PG Toggle for Variants -->
      <div *ngIf="calculationResult?.returnsVariantB" class="flex justify-content-center gap-2 mb-4">
        <button type="button" class="btn-toggle text-xs" [class.active]="simplifiedVariant === 'A'"
          (click)="simplifiedVariant = 'A'">Variant A: Standard Growth</button>
        <button type="button" class="btn-toggle text-xs" [class.active]="simplifiedVariant === 'B'"
          (click)="simplifiedVariant = 'B'">Variant B: Data-Anchored Projections</button>
      </div>

      <!-- VARIANT A OR UG VIEW -->
      <div *ngIf="!calculationResult?.returnsVariantB || simplifiedVariant === 'A'" class="flex flex-column gap-4">
        <!-- The Verdict Box -->
        <div
          class="simplified-card verdict-card border-round-xl p-4 shadow-1 border-left-3 border-green-500 bg-green-50-alpha">
          <div class="flex align-items-start gap-3">
            <span
              class="icon-circle bg-green-500 text-white flex align-items-center justify-content-center border-circle shadow-1"
              style="width: 32px; height: 32px; flex-shrink: 0;">
              <i class="pi pi-check text-xs font-bold"></i>
            </span>
            <div class="flex-grow-1">
              <span class="card-label font-bold text-green-700 tracking-wider text-xs block mb-1">THE VERDICT:</span>
              <p class="verdict-statement text-950 font-semibold text-sm line-height-3 m-0">
                {{ calculationResult?.verdict }}
              </p>
            </div>
          </div>
        </div>

        <!-- Next Steps Box -->
        <div
          class="simplified-card loan-card border-round-xl p-4 shadow-1 border-left-3 border-green-500 bg-green-50-alpha"
          *ngIf="calculationResult?.recommendation">
          <div class="flex align-items-start gap-3">
            <span
              class="icon-circle bg-green-500 text-white flex align-items-center justify-content-center border-circle shadow-1"
              style="width: 32px; height: 32px; flex-shrink: 0;">
              <i class="pi pi-send text-xs font-bold"></i>
            </span>
            <div class="flex-grow-1">
              <span class="card-label font-bold text-green-700 tracking-wider text-xs block mb-1">YOUR NEXT STEP:</span>
              <p class="next-step-statement text-800 font-semibold line-height-3 m-0 text-sm">
                Apply for scholarships to reduce your costs. Start your application. Consider an education loan â€” your
                ROI makes it financially sound.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- VARIANT B VIEW (PG ONLY) -->
      <div *ngIf="calculationResult?.returnsVariantB && simplifiedVariant === 'B'" class="flex flex-column gap-4">
        <!-- The Verdict Box (Green Theme) -->
        <div
          class="simplified-card verdict-card border-round-xl p-4 shadow-1 border-left-3 border-green-500 bg-green-50-alpha">
          <div class="flex align-items-start gap-3">
            <span
              class="icon-circle bg-green-500 text-white flex align-items-center justify-content-center border-circle shadow-1"
              style="width: 32px; height: 32px; flex-shrink: 0;">
              <i class="pi pi-check text-xs font-bold"></i>
            </span>
            <div class="flex-grow-1">
              <span class="card-label font-bold text-green-700 tracking-wider text-xs block mb-1">THE VERDICT (VARIANT
                B):</span>
              <p class="verdict-statement text-950 font-semibold text-sm line-height-3 m-0">
                {{ calculationResult?.verdictVariantB }}
              </p>
            </div>
          </div>
        </div>

        <!-- Next Steps Box (Green Theme) -->
        <div
          class="simplified-card loan-card border-round-xl p-4 shadow-1 border-left-3 border-green-500 bg-green-50-alpha"
          *ngIf="calculationResult?.recommendationVariantB">
          <div class="flex align-items-start gap-3">
            <span
              class="icon-circle bg-green-500 text-white flex align-items-center justify-content-center border-circle shadow-1"
              style="width: 32px; height: 32px; flex-shrink: 0;">
              <i class="pi pi-send text-xs font-bold"></i>
            </span>
            <div class="flex-grow-1">
              <span class="card-label font-bold text-green-700 tracking-wider text-xs block mb-1">YOUR NEXT STEP
                (VARIANT B):</span>
              <p class="next-step-statement text-800 font-semibold line-height-3 m-0 text-sm">
                Apply for scholarships to reduce your costs. Start your application. Consider an education loan â€” your
                ROI makes it financially sound.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Compare with Other Universities Button -->
      <div class="flex flex-column align-items-center gap-3 mt-4 pt-3 border-top-1 border-gray-100">
        <button pButton pRipple type="button" label="Compare with Other Universities"
          class="bg-blue-600 hover:bg-blue-700 border-none px-5 py-3 font-extrabold text-md border-round-lg text-white shadow-2 w-full"
          (click)="resetCalculator()">
        </button>
        <a class="text-600 font-bold hover:underline cursor-pointer text-sm" (click)="goBackToDashboard()">Close</a>
      </div>
    </div>
  </p-dialog>

  <!-- VIEW 4: Popup Form Dialog -->
  <p-dialog [(visible)]="formDialogVisible" [modal]="true" [responsive]="true" [dismissableMask]="true"
    [closable]="false" [draggable]="false" [resizable]="false"
    styleClass="w-full md:w-11 xl:w-9 mx-auto border-round-3xl overflow-hidden shadow-4" contentStyleClass="p-0"
    style="background: transparent;">

    <!-- Custom Full Header -->
    <div class="w-full text-center relative flex flex-column justify-content-center"
      style="background-color: #cddc39; padding: 2rem 1rem;">
      <h2 class="m-0 font-extrabold text-4xl" style="color: #0b1c77; letter-spacing: -0.02em;">ROI Calculator</h2>
      <p class="m-0 font-bold mt-2" style="color: #555555;">Fill out the details</p>

      <!-- Custom Close Button -->
      <button
        class="absolute p-link flex align-items-center justify-content-center border-circle transition-transform transition-duration-200 hover:scale-105 cursor-pointer shadow-2"
        style="right: 2.5rem; top: 50%; transform: translateY(-50%); width: 35px; height: 35px; background-color: #0b1c77; border: none;"
        (click)="formDialogVisible = false">
        <i class="pi pi-times text-white text-sm font-bold"></i>
      </button>
    </div>

    <div class="p-4 md:p-6" style="background-color: #ffffff;">
      <form [formGroup]="roiForm" (ngSubmit)="calculateRoi()" class="flex flex-column" autocomplete="off">
        <div class="grid m-0 p-0 w-full justify-content-between">

          <!-- STEP 1 -->
          <div class="col-12 lg:col-6 p-2">
            <div class="h-full"
              style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
              <div class="flex align-items-center gap-3 p-3"
                style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
                <span class="flex align-items-center justify-content-center border-circle text-white font-bold"
                  style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">1</span>
                <h2 class="m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Program Details</h2>
              </div>

              <div class="p-4 flex flex-column gap-4">
                <!-- Form Grid Start -->
                <div class="flex flex-column sm:flex-row gap-4">
                  <div class="field w-full sm:w-6 mb-0">
                    <label for="planToStart-dialog" class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                      style="letter-spacing: 0.05em;">When do you plan to start?</label>
                    <p-dropdown id="planToStart-dialog" [options]="startYears" formControlName="planToStart"
                      optionLabel="name" optionValue="code" placeholder="Select start year"
                      styleClass="w-full border-round-md" appendTo="body"></p-dropdown>
                  </div>

                  <div class="field w-full sm:w-6">
                    <label for="university-template"
                      class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                      style="letter-spacing: 0.05em;">Which university?</label>
                    <div class="university-wrapper" [class.is-locked]="!roiForm.get('level')?.value">
                      <p-autoComplete id="university-template" formControlName="university"
                        [suggestions]="universitySearchSuggestions" (completeMethod)="searchUniversities($event)"
                        field="name" placeholder="Search university..." styleClass="w-full" [dropdown]="true"
                        forceSelection="true" [disabled]="!roiForm.get('level')?.value">
                      </p-autoComplete>
                    </div>
                    <small *ngIf="!roiForm.get('level')?.value" class="text-xs text-500 italic mt-1 block">
                      Please select level of study first.
                    </small>
                  </div>
                </div>

                <div class="field mb-0">
                  <label class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                    style="letter-spacing: 0.05em;">What level of study?</label>
                  <div class="flex p-1 border-round-lg" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
                    <button type="button"
                      class="w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md"
                      [ngStyle]="{'background-color': roiForm.get('level')?.value === 'UG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'UG' ? '#ffffff' : '#0f172a'}"
                      (click)="roiForm.get('level')?.setValue('UG')">
                      Undergraduate
                    </button>
                    <button type="button"
                      class="w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md"
                      [ngStyle]="{'background-color': roiForm.get('level')?.value === 'PG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'PG' ? '#ffffff' : '#0f172a', 'box-shadow': roiForm.get('level')?.value === 'PG' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'}"
                      (click)="roiForm.get('level')?.setValue('PG')">
                      Postgraduate
                    </button>
                  </div>
                </div>

                <div class="flex flex-column sm:flex-row gap-4" *ngIf="roiForm.get('level')?.value === 'PG'">
                  <div class="field w-full sm:w-6 mb-0">
                    <label for="school-dialog" class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                      style="letter-spacing: 0.05em;">Which school?</label>
                    <p-dropdown id="school-dialog" [options]="schoolsList" formControlName="school" optionLabel="name"
                      placeholder="Select school" styleClass="w-full border-round-md"
                      [disabled]="isLoadingCourses || schoolsList.length === 0" appendTo="body"></p-dropdown>
                    <span *ngIf="isLoadingCourses" class="text-xs text-500 italic mt-1 block"><i
                        class="pi pi-spin pi-spinner mr-1"></i> Loading schools...</span>
                  </div>

                  <div class="field w-full sm:w-6 mb-0" *ngIf="roiForm.get('school')?.value">
                    <label for="course-dialog" class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                      style="letter-spacing: 0.05em;">Which course?</label>
                    <p-dropdown id="course-dialog" [options]="coursesList" formControlName="course" optionLabel="name"
                      placeholder="Select course" styleClass="w-full border-round-md"
                      [disabled]="coursesList.length === 0" appendTo="body"></p-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- STEP 2 -->
          <div class="col-12 lg:col-6 p-2">
            <div class="h-full"
              style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
              <div class="flex align-items-center gap-3 p-3"
                style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
                <span class="flex align-items-center justify-content-center border-circle text-white font-bold"
                  style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">2</span>
                <h2 class="m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Financial Situation</h2>
              </div>

              <div class="p-4 flex flex-column gap-4">
                <div class="field mb-0">
                  <label class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                    style="letter-spacing: 0.05em;">Do you have any scholarships secured?</label>
                  <div class="flex gap-3">
                    <button type="button"
                      class="w-3 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                      [ngStyle]="{'background-color': hasScholarship ? '#cddc39' : '#ffffff', 'color': hasScholarship ? '#0b1c77' : '#64748b', 'border': hasScholarship ? 'none' : '1px solid #e2e8f0'}"
                      (click)="toggleScholarship(true)">
                      Yes
                    </button>
                    <button type="button"
                      class="w-3 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                      [ngStyle]="{'background-color': !hasScholarship ? '#ffffff' : '#ffffff', 'color': !hasScholarship ? '#0b1c77' : '#64748b', 'border': !hasScholarship ? '1px solid #cbd5e1' : '1px solid #e2e8f0'}"
                      (click)="toggleScholarship(false)">
                      No
                    </button>
                  </div>
                </div>

                <div class="field mb-0" *ngIf="hasScholarship">
                  <label for="scholarshipAmount-dialog"
                    class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                    style="letter-spacing: 0.05em;">Scholarship Amount</label>
                  <div class="p-inputgroup border-round-md" style="border: 1px solid #e2e8f0; overflow: hidden;">
                    <span class="p-inputgroup-addon bg-yellow-50 text-blue-900 font-bold border-none">{{ currencySymbol
                      }}</span>
                    <input pInputText id="scholarshipAmount-dialog" type="number" formControlName="scholarshipAmount"
                      placeholder="10,000" class="w-full border-none shadow-none focus:shadow-none">
                  </div>
                </div>

                <div class="field mb-0" [ngClass]="{'mt-3': !hasScholarship}">
                  <label class="text-xs font-extrabold text-blue-900 uppercase block mb-2"
                    style="letter-spacing: 0.05em;">Living:</label>
                  <div class="flex flex-wrap gap-3 align-items-center w-full">
                    <!-- On Campus -->
                    <div
                      class="flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                      [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#cddc39' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#cddc39' : '#e2e8f0'}"
                      (click)="roiForm.get('livingSituation')?.setValue('On-campus')">
                      <i class="pi pi-circle"
                        [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'On-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'On-campus'}"></i>
                      <span class="text-sm font-bold"
                        [ngClass]="{'text-900': roiForm.get('livingSituation')?.value === 'On-campus', 'text-700': roiForm.get('livingSituation')?.value !== 'On-campus'}">On-campus</span>
                    </div>
                    <!-- Off Campus -->
                    <div
                      class="flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                      [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Off-campus' ? '#cddc39' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'Off-campus' ? '#cddc39' : '#e2e8f0'}"
                      (click)="roiForm.get('livingSituation')?.setValue('Off-campus')">
                      <i class="pi pi-circle"
                        [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Off-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Off-campus'}"></i>
                      <span class="text-sm font-bold"
                        [ngClass]="{'text-900': roiForm.get('livingSituation')?.value === 'Off-campus', 'text-700': roiForm.get('livingSituation')?.value !== 'Off-campus'}">Off-campus</span>
                    </div>
                    <!-- Living with relatives -->
                    <div
                      class="flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                      [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#cddc39' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#cddc39' : '#e2e8f0'}"
                      (click)="roiForm.get('livingSituation')?.setValue('Living with relatives')">
                      <i class="pi pi-circle"
                        [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Living with relatives', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Living with relatives'}"></i>
                      <span class="text-sm font-bold"
                        [ngClass]="{'text-900': roiForm.get('livingSituation')?.value === 'Living with relatives', 'text-700': roiForm.get('livingSituation')?.value !== 'Living with relatives'}">Living
                        with relatives (free)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Recommendation Checkbox Banner (matches image perfectly) -->
        <div class="flex justify-content-center mt-4 mb-4">
          <div class="flex align-items-center px-4 py-3 border-round-3xl cursor-pointer"
            style="background-color: #fcfdee; border: 1px solid #cddc39;"
            (click)="roiForm.get('loanRecommendation')?.setValue(!roiForm.get('loanRecommendation')?.value)">
            <!-- Custom solid dark blue circle with white checkmark -->
            <div class="flex align-items-center justify-content-center border-circle mr-3"
              [ngStyle]="{'background-color': roiForm.get('loanRecommendation')?.value ? '#000885' : '#ffffff', 'border': roiForm.get('loanRecommendation')?.value ? 'none' : '1px solid #cbd5e1', 'width': '22px', 'height': '22px'}">
              <i class="pi pi-check text-white" style="font-size: 0.7rem;"
                *ngIf="roiForm.get('loanRecommendation')?.value"></i>
            </div>
            <!-- Invisible real checkbox for form control -->
            <input type="checkbox" formControlName="loanRecommendation" class="hidden">
            <label class="cursor-pointer text-700 text-sm m-0 pointer-events-none">
              I would also like a <span class="text-blue-900 font-extrabold">personalised loan recommendation</span>
              based on my profile.
            </label>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-content-center mb-2">
          <button type="submit"
            class="border-none cursor-pointer flex align-items-center justify-content-center gap-2 text-white border-round-lg shadow-2 transition-transform transition-duration-200 hover:scale-105"
            style="background-color: #000885; padding: 1rem 4rem; font-weight: 800; font-size: 1.05rem;"
            [disabled]="isLoading">
            <i class="pi pi-calculator" *ngIf="!isLoading"></i>
            <i class="pi pi-spin pi-spinner" *ngIf="isLoading"></i>
            <span>Calculate My ROI</span>
          </button>
        </div>

      </form>
    </div>
  </p-dialog>
</div>

<ng-template #roiFormTemplate>
  <form [formGroup]="roiForm" (ngSubmit)="calculateRoi()" class="flex flex-column" autocomplete="off">
    <div class="grid m-0 p-0 w-full justify-content-between">

      <!-- STEP 1 -->
      <div class="col-12 lg:col-6 p-2">
        <div class="step-card h-full"
          style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
          <div class="step-header flex align-items-center gap-3 p-3"
            style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
            <span class="step-number flex align-items-center justify-content-center border-circle text-white font-bold"
              style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">1</span>
            <h2 class="step-title m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Program Details</h2>
          </div>

          <div class="step-content p-4 flex flex-column gap-4">
            <!-- Form Grid Start -->
            <div class="form-grid flex flex-column sm:flex-row gap-4">
              <div class="field w-full sm:w-6">
                <label for="planToStart-template"
                  class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">When do you plan to start?</label>
                <p-dropdown id="planToStart-template" [options]="startYears" formControlName="planToStart"
                  optionLabel="name" optionValue="code" placeholder="Select start year" styleClass="w-full"
                  appendTo="body"></p-dropdown>
              </div>

              <div class="field w-full sm:w-6">
                <label for="university-template"
                  class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which university?</label>
                <p-autoComplete id="university-template" formControlName="university"
                  [suggestions]="universitySearchSuggestions" (completeMethod)="searchUniversities($event)" field="name"
                  placeholder="Search university..." styleClass="w-full" [dropdown]="true" forceSelection="true">
                </p-autoComplete>
              </div>
            </div>

            <div class="field">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">What level of study?</label>
              <div class="segmented-control flex p-1 border-round-lg"
                style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
                <button type="button"
                  class="segmented-btn w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md"
                  [ngStyle]="{'background-color': roiForm.get('level')?.value === 'UG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'UG' ? '#ffffff' : '#0f172a'}"
                  (click)="roiForm.get('level')?.setValue('UG')">
                  Undergraduate
                </button>
                <button type="button"
                  class="segmented-btn w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md shadow-1"
                  [ngStyle]="{'background-color': roiForm.get('level')?.value === 'PG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'PG' ? '#ffffff' : '#0f172a'}"
                  (click)="roiForm.get('level')?.setValue('PG')">
                  Postgraduate
                </button>
              </div>
            </div>

            <div class="form-grid flex flex-column sm:flex-row gap-4" *ngIf="roiForm.get('level')?.value === 'PG'">
              <div class="field w-full sm:w-6">
                <label for="school-template"
                  class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which school?</label>
                <p-dropdown id="school-template" [options]="schoolsList" formControlName="school" optionLabel="name"
                  placeholder="Select school" styleClass="w-full"
                  [disabled]="isLoadingCourses || schoolsList.length === 0" appendTo="body"></p-dropdown>
                <span *ngIf="isLoadingCourses" class="text-xs text-500 italic mt-1 block"><i
                    class="pi pi-spin pi-spinner mr-1"></i> Loading schools...</span>
              </div>

              <div class="field w-full sm:w-6" *ngIf="roiForm.get('school')?.value">
                <label for="course-template"
                  class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which course?</label>
                <p-dropdown id="course-template" [options]="coursesList" formControlName="course" optionLabel="name"
                  placeholder="Select course" styleClass="w-full" [disabled]="coursesList.length === 0"
                  appendTo="body"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 2 -->
      <div class="col-12 lg:col-6 p-2">
        <div class="step-card h-full"
          style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
          <div class="step-header flex align-items-center gap-3 p-3"
            style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
            <span class="step-number flex align-items-center justify-content-center border-circle text-white font-bold"
              style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">2</span>
            <h2 class="step-title m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Financial Situation</h2>
          </div>

          <div class="step-content p-4 flex flex-column gap-4">
            <div class="field">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Do you have any scholarships secured?</label>
              <div class="scholarship-toggle flex gap-3">
                <button type="button"
                  class="toggle-btn w-4 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                  [ngStyle]="{'background-color': hasScholarship ? '#cddc39' : '#ffffff', 'color': hasScholarship ? '#0b1c77' : '#64748b', 'border': hasScholarship ? 'none' : '1px solid #e2e8f0'}"
                  (click)="toggleScholarship(true)">
                  Yes
                </button>
                <button type="button"
                  class="toggle-btn w-4 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                  [ngStyle]="{'background-color': !hasScholarship ? '#ffffff' : '#ffffff', 'color': !hasScholarship ? '#0b1c77' : '#64748b', 'border': !hasScholarship ? '1px solid #cbd5e1' : '1px solid #e2e8f0'}"
                  (click)="toggleScholarship(false)">
                  No
                </button>
              </div>
            </div>

            <div class="field" *ngIf="hasScholarship">
              <label for="scholarshipAmount"
                class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Scholarship Amount</label>
              <div class="p-inputgroup border-round-md" style="border: 1px solid #e2e8f0; overflow: hidden;">
                <span class="p-inputgroup-addon bg-yellow-50 text-blue-900 font-bold border-none">{{ currencySymbol
                  }}</span>
                <input pInputText id="scholarshipAmount" type="number" formControlName="scholarshipAmount"
                  placeholder="10,000" class="w-full border-none shadow-none focus:shadow-none">
              </div>
            </div>

            <div class="field mt-3">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Living:</label>
              <div class="living-segmented flex flex-wrap gap-3 align-items-center w-full">
                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#ffffff' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#cbd5e1' : '#e2e8f0'}"
                  (click)="roiForm.get('livingSituation')?.setValue('On-campus')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'On-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'On-campus'}"></i>
                  <span class="text-sm font-bold text-700">On-campus</span>
                </div>

                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-none shadow-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Off-campus' ? '#cddc39' : '#ffffff'}"
                  (click)="roiForm.get('livingSituation')?.setValue('Off-campus')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Off-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Off-campus'}"></i>
                  <span class="text-sm font-bold text-900">Off-campus</span>
                </div>

                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#ffffff' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#cbd5e1' : '#e2e8f0'}"
                  (click)="roiForm.get('livingSituation')?.setValue('Living with relatives')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Living with relatives', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Living with relatives'}"></i>
                  <span class="text-sm font-bold text-700">Living with relatives (free)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recommendation Checkbox Banner -->
    <div class="flex justify-content-center mt-4 mb-2">
      <div class="loan-banner flex align-items-center px-4 py-3 border-round-3xl cursor-pointer"
        style="background-color: #fcfdee; border: 1px solid #cddc39;"
        (click)="roiForm.get('loanRecommendation')?.setValue(!roiForm.get('loanRecommendation')?.value)">
        <p-checkbox formControlName="loanRecommendation" [binary]="true" id="loanRec" class="mr-3">
        </p-checkbox>
        <label for="loanRec" class="cursor-pointer text-700 text-sm m-0 pointer-events-none">
          I would also like a <span class="text-blue-900 font-extrabold">personalised loan recommendation</span> based
          on my profile.
        </label>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="flex justify-content-center mt-2 mb-4">
      <button type="submit"
        class="border-none cursor-pointer flex align-items-center justify-content-center gap-2 text-white border-round-lg shadow-2 transition-transform transition-duration-200 hover:scale-105"
        style="background-color: #000885; padding: 1rem 4rem; font-weight: 800; font-size: 1.05rem;"
        [disabled]="isLoading">
        <i class="pi pi-calculator" *ngIf="!isLoading"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="isLoading"></i>
        <span>Calculate My ROI</span>
      </button>
      <!-- STEP 1 -->
      <div class="col-12 lg:col-6 p-2">
        <div class="step-card h-full"
          style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
          <div class="step-header flex align-items-center gap-3 p-3"
            style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
            <span class="step-number flex align-items-center justify-content-center border-circle text-white font-bold"
              style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">1</span>
            <h2 class="step-title m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Program Details</h2>
          </div>

          <div class="step-content p-4 flex flex-column gap-4">
            <!-- Form Grid Start -->
            <div class="form-grid flex flex-column sm:flex-row gap-4">
              <div class="field w-full sm:w-6">
                <label for="planToStart" class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">When do you plan to start?</label>
                <p-dropdown id="planToStart" [options]="startYears" formControlName="planToStart" optionLabel="name"
                  optionValue="code" placeholder="Select start year" styleClass="w-full"></p-dropdown>
              </div>

              <div class="field w-full sm:w-6">
                <label for="university" class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which university?</label>
                <p-autoComplete id="university" formControlName="university" [suggestions]="universitySearchSuggestions"
                  (completeMethod)="searchUniversities($event)" field="name" placeholder="Search university..."
                  styleClass="w-full" [dropdown]="true" forceSelection="true">
                </p-autoComplete>
              </div>
            </div>

            <div class="field">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">What level of study?</label>
              <div class="segmented-control flex p-1 border-round-lg"
                style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
                <button type="button"
                  class="segmented-btn w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md"
                  [ngStyle]="{'background-color': roiForm.get('level')?.value === 'UG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'UG' ? '#ffffff' : '#0f172a'}"
                  (click)="roiForm.get('level')?.setValue('UG')">
                  Undergraduate
                </button>
                <button type="button"
                  class="segmented-btn w-6 border-none py-2 text-sm font-bold cursor-pointer transition-colors transition-duration-200 border-round-md shadow-1"
                  [ngStyle]="{'background-color': roiForm.get('level')?.value === 'PG' ? '#0b1c77' : 'transparent', 'color': roiForm.get('level')?.value === 'PG' ? '#ffffff' : '#0f172a'}"
                  (click)="roiForm.get('level')?.setValue('PG')">
                  Postgraduate
                </button>
              </div>
            </div>

            <div class="form-grid flex flex-column sm:flex-row gap-4" *ngIf="roiForm.get('level')?.value === 'PG'">
              <div class="field w-full sm:w-6">
                <label for="school" class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which school?</label>
                <p-dropdown id="school" [options]="schoolsList" formControlName="school" optionLabel="name"
                  placeholder="Select school" styleClass="w-full"
                  [disabled]="isLoadingCourses || schoolsList.length === 0"></p-dropdown>
                <span *ngIf="isLoadingCourses" class="text-xs text-500 italic mt-1 block"><i
                    class="pi pi-spin pi-spinner mr-1"></i> Loading schools...</span>
              </div>

              <div class="field w-full sm:w-6" *ngIf="roiForm.get('school')?.value">
                <label for="course" class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                  style="letter-spacing: 0.05em;">Which course?</label>
                <p-dropdown id="course" [options]="coursesList" formControlName="course" optionLabel="name"
                  placeholder="Select course" styleClass="w-full" [disabled]="coursesList.length === 0"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 2 -->
      <div class="col-12 lg:col-6 p-2">
        <div class="step-card h-full"
          style="border: 1px solid #e0e7ff; border-radius: 12px; overflow: hidden; background-color: #ffffff;">
          <div class="step-header flex align-items-center gap-3 p-3"
            style="background-color: #eef2ff; border-bottom: 1px solid #e0e7ff;">
            <span class="step-number flex align-items-center justify-content-center border-circle text-white font-bold"
              style="background-color: #000885; width: 28px; height: 28px; font-size: 0.85rem;">2</span>
            <h2 class="step-title m-0 text-blue-900 font-bold" style="font-size: 1.05rem;">Your Financial Situation</h2>
          </div>

          <div class="step-content p-4 flex flex-column gap-4">
            <div class="field">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Do you have any scholarships secured?</label>
              <div class="scholarship-toggle flex gap-3">
                <button type="button"
                  class="toggle-btn w-4 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                  [ngStyle]="{'background-color': hasScholarship ? '#cddc39' : '#ffffff', 'color': hasScholarship ? '#0b1c77' : '#64748b', 'border': hasScholarship ? 'none' : '1px solid #e2e8f0'}"
                  (click)="toggleScholarship(true)">
                  Yes
                </button>
                <button type="button"
                  class="toggle-btn w-4 border-none py-2 font-bold cursor-pointer transition-colors transition-duration-200 border-round-lg shadow-1"
                  [ngStyle]="{'background-color': !hasScholarship ? '#ffffff' : '#ffffff', 'color': !hasScholarship ? '#0b1c77' : '#64748b', 'border': !hasScholarship ? '1px solid #cbd5e1' : '1px solid #e2e8f0'}"
                  (click)="toggleScholarship(false)">
                  No
                </button>
              </div>
            </div>

            <div class="field" *ngIf="hasScholarship">
              <label for="scholarshipAmount"
                class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Scholarship Amount</label>
              <div class="p-inputgroup border-round-md" style="border: 1px solid #e2e8f0; overflow: hidden;">
                <span class="p-inputgroup-addon bg-yellow-50 text-blue-900 font-bold border-none">{{ currencySymbol
                  }}</span>
                <input pInputText id="scholarshipAmount" type="number" formControlName="scholarshipAmount"
                  placeholder="10,000" class="w-full border-none shadow-none focus:shadow-none">
              </div>
            </div>

            <div class="field mt-3">
              <label class="label-heading text-xs font-extrabold text-blue-900 uppercase block mb-2"
                style="letter-spacing: 0.05em;">Living:</label>
              <div class="living-segmented flex flex-wrap gap-3 align-items-center w-full">
                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#ffffff' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'On-campus' ? '#cbd5e1' : '#e2e8f0'}"
                  (click)="roiForm.get('livingSituation')?.setValue('On-campus')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'On-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'On-campus'}"></i>
                  <span class="text-sm font-bold text-700">On-campus</span>
                </div>

                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-none shadow-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Off-campus' ? '#cddc39' : '#ffffff'}"
                  (click)="roiForm.get('livingSituation')?.setValue('Off-campus')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Off-campus', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Off-campus'}"></i>
                  <span class="text-sm font-bold text-900">Off-campus</span>
                </div>

                <div
                  class="living-option flex align-items-center gap-2 cursor-pointer border-round-3xl px-3 py-2 transition-colors transition-duration-200 border-1"
                  [ngStyle]="{'background-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#ffffff' : '#ffffff', 'border-color': roiForm.get('livingSituation')?.value === 'Living with relatives' ? '#cbd5e1' : '#e2e8f0'}"
                  (click)="roiForm.get('livingSituation')?.setValue('Living with relatives')">
                  <i class="pi pi-circle"
                    [ngClass]="{'pi-circle-fill text-blue-900': roiForm.get('livingSituation')?.value === 'Living with relatives', 'pi-circle text-400': roiForm.get('livingSituation')?.value !== 'Living with relatives'}"></i>
                  <span class="text-sm font-bold text-700">Living with relatives (free)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recommendation Checkbox Banner -->
    <div class="flex justify-content-center mt-4 mb-2">
      <div class="loan-banner flex align-items-center px-4 py-3 border-round-3xl cursor-pointer"
        style="background-color: #fcfdee; border: 1px solid #cddc39;"
        (click)="roiForm.get('loanRecommendation')?.setValue(!roiForm.get('loanRecommendation')?.value)">
        <p-checkbox formControlName="loanRecommendation" [binary]="true" id="loanRec" class="mr-3">
        </p-checkbox>
        <label for="loanRec" class="cursor-pointer text-700 text-sm m-0 pointer-events-none">
          I would also like a <span class="text-blue-900 font-extrabold">personalised loan recommendation</span> based
          on my profile.
        </label>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="flex justify-content-center mt-2 mb-4">
      <button type="submit"
        class="border-none cursor-pointer flex align-items-center justify-content-center gap-2 text-white border-round-lg shadow-2 transition-transform transition-duration-200 hover:scale-105"
        style="background-color: #000885; padding: 1rem 4rem; font-weight: 800; font-size: 1.05rem;"
        [disabled]="isLoading">
        <i class="pi pi-calculator" *ngIf="!isLoading"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="isLoading"></i>
        <span>Calculate My ROI</span>
      </button>
    </div>
  </form>
</ng-template>